import MUIAvatar from '@material-ui/core/Avatar';

const Avatar = ({ children, ...otherProps }) => {
  return (<MUIAvatar {...otherProps}>{ children }</MUIAvatar>)
}

export default Avatar